<template>
  <div class="upload-container">
    <el-upload
      :data="dataObj"
      :multiple="false"
      :show-file-list="false"
      :on-success="handleImageSuccess"
      :before-upload="beforeUpload"
      class="image-uploader"
      drag
      :action="uploadUrl"
    >
      <i class="el-icon-upload" />
      <div class="el-upload__text">
        将文件拖到此处，或<em>点击上传</em>
      </div>
    </el-upload>
    <div v-if="tempUrl" class="image-preview">
      <div class="image-preview-wrapper">
        <img :src="tempUrl">
        <div class="image-preview-action">
          <i class="el-icon-delete" @click="rmImage(item)" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, removeToken } from '@/utils/auth';

export default {
  name: 'SingleImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tempUrl: "",
      dataObj: { token: '', key: '' },
      uploadUrl: process.env.VUE_APP_BASE_API+'/sys/oss/upload'
    }
  },
  computed: {
    imageUrl() {
      return this.value
    }
  },
  methods: {
    rmImage(value) {
      this.tempUrl = '';
      this.$emit('submit',this.tempUrl);
    },
    emitInput(val) {
      this.$emit('input', val)
    },
    handleImageSuccess(res,file) {
      if (res.code == 0){
        this.tempUrl = res.url;
        this.$emit('submit',this.tempUrl);
      }else{
        this.$message({
          message: '上传失败',
          type: 'error',
          showClose: true
        })
        return false
      }
    },
    beforeUpload() {
      const _self = this;
      _self._data.dataObj.token = getToken();
    }
  }
}
</script>

<style lang="scss" scoped>
    @import "~@/styles/mixin.scss";
    .upload-container {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        @include clearfix;
        .image-uploader {
            width: 60%;
            float: left;
        }
        .image-preview {
            width: 60%;
            position: relative;
            border: 1px dashed #d9d9d9;
            display: flex;
            flex-wrap: wrap;
            .image-preview-wrapper {
                position: relative;
                width: 100%;
                height: 100%;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
            .image-preview-action {
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                cursor: default;
                text-align: center;
                color: #fff;
                opacity: 0;
                font-size: 20px;
                background-color: rgba(0, 0, 0, .5);
                transition: opacity .3s;
                cursor: pointer;
                text-align: center;
                line-height: 200px;
                .el-icon-delete {
                    font-size: 36px;
                }
            }
            &:hover {
                .image-preview-action {
                    opacity: 1;
                }
            }
        }
    }

</style>
